import CategoryActionType from '../actionTypes/CategoryActionType';

const initialState = { listProduct: [] };

export default (state = initialState, action) => {
  switch (action.type) {
    case CategoryActionType.UPDATE_ALL_CATEGORY:
      return { ...state, allCategories: action.allCategories };
    default:
      return state;
  }
};
